<template>
  <v-dialog v-model="isOpened" persistent max-width="680px">
    <v-card>
      <v-card-title class="text-h5">請求書送付先 変更</v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="isValid" lazy-validation>
          <v-textarea
            v-model="values.address_plan"
            label="契約者"
            rows="7"
            hide-details="auto"
            auto-grow
            readonly
          ></v-textarea>
          <v-checkbox
            v-model="values.use_inquiry_address"
            label="契約者と請求書送付先が異なる"
            color="primary"
            hide-details="auto"
            density="compact"
            @update:modelValue="toggleDetail"
          ></v-checkbox>
          <div v-show="values.use_inquiry_address">
            <div class="text-caption" style="_font-size: 0.75em">※入力した内容が請求書(翌月以降)に反映されます。</div>
            <v-textarea
              v-model.trim="values.address_fulltext"
              :rules="addressRules"
              label="請求書送付先"
              rows="7"
              class="mb-2"
              auto-grow
            ></v-textarea>
            <v-select v-model="values.honorific_title_type" label="敬称" :items="HonorificTitleTypeList"></v-select>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-card-text align="left">
          <v-btn :disabled="isPushed" variant="elevated" @click="close()"> キャンセル </v-btn>
        </v-card-text>
        <v-card-text align="right">
          <v-btn color="primary" :disabled="isUncommittable" variant="elevated" @click="execSave()">
            <span>更新</span>
          </v-btn>
        </v-card-text>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script src="./BillingAddressDialog.vue.js"></script>
